import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRam = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	className: "ram",
	viewBox: "0 0 64 64",
	enableBackground: "new 0 0 64 64",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "m49.9 36.8c-.6-.9-1.5-1.5-2.6-1.5-1.7 0-3.1 1.5-3.1 3.4v12.3c0 1.9 1.4 3.4 3.1 3.4 1.7 0 3.1-1.5 3.1-3.4v-4.5-7.9c0-.5-.2-1.2-.5-1.8",
			fill: "#8d9ba3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m47.3 54.6c1.7 0 3.1-1.5 3.1-3.4h-6.2c0 1.8 1.4 3.4 3.1 3.4",
			fill: "#3e4347"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m41.7 38.4c-.8-1.3-2-2.2-3.4-2.2-2.3 0-4.2 2.2-4.2 5v15.8c0 2.8 1.9 5 4.2 5 2.3 0 4.2-2.2 4.2-5v-6.5-9.2c-.1-1.1-.4-2-.8-2.9",
			fill: "#8d9ba3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m38.3 62c2.3 0 4.2-2.2 4.2-5h-8.3c-.1 2.8 1.8 5 4.1 5",
			fill: "#3e4347"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m28.9 38.4c-.8-1.3-2-2.2-3.4-2.2-2.3 0-4.2 2.2-4.2 5v15.8c0 2.8 1.9 5 4.2 5 2.3 0 4.2-2.2 4.2-5v-6.5-9.2c-.1-1.1-.3-2-.8-2.9",
			fill: "#8d9ba3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m25.5 62c2.3 0 4.2-2.2 4.2-5h-8.3c-.1 2.8 1.8 5 4.1 5",
			fill: "#3e4347"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m58.1 33.6c-.7-1.2-1.8-2-3-2-2 0-3.6 2-3.6 4.5v16.3c0 2.5 1.6 4.5 3.6 4.5 2 0 3.6-2 3.6-4.5v-5.9-10.3c.1-1-.2-1.8-.6-2.6",
			fill: "#8d9ba3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m55.1 57.1c2 0 3.6-2 3.6-4.5h-7.3c.1 2.4 1.7 4.5 3.7 4.5",
			fill: "#3e4347"
		}),
		/* @__PURE__ */ _jsxs("g", {
			fill: "#dae5ef",
			children: [
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 38.3,
					cy: 34.6,
					rx: 14.3,
					ry: 13.9
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 22.1,
					cy: 33.5,
					rx: 14.3,
					ry: 13.9
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 25.5,
					cy: 21.4,
					rx: 14.3,
					ry: 13.9
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 37.9,
					cy: 21.4,
					rx: 14.3,
					ry: 13.9
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 52.6,
					cy: 29.2,
					rx: 9.1,
					ry: 8.9
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 52.8,
					cy: 39.3,
					rx: 9.1,
					ry: 8.9
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 49.4,
					cy: 40.7,
					rx: 9.1,
					ry: 8.9
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 22.6,
					cy: 43.4,
					rx: 9.1,
					ry: 8.9
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 41.1,
					cy: 43.4,
					rx: 9.1,
					ry: 8.9
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 31.9,
					cy: 47.2,
					rx: 9.1,
					ry: 8.9
				})
			]
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m51.4 33.8c.1-3.7-.5-6.8-1.7-8.6-1.9-1.1-5.2-1.7-9.3-1.6-.1 3.7.5 6.8 1.7 8.6 1.9 1.1 5.2 1.6 9.3 1.6",
			fill: "#8d9ba3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m49 31.5c.1-2.1-.3-3.8-1-4.8-1.1-.6-2.9-1-5.2-.9-.1 2.1.3 3.8 1 4.8 1 .6 2.9.9 5.2.9",
			fill: "#3e4347"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m23.5 23.5c-4-.1-7.3.4-9.3 1.6-1.2 1.8-1.9 4.8-1.8 8.5 4 .1 7.3-.4 9.3-1.6 1.2-1.7 1.9-4.7 1.8-8.5",
			fill: "#8d9ba3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m21 25.7c-2.3-.1-4.1.2-5.3.9-.7 1-1.1 2.7-1 4.8 2.3.1 4.1-.2 5.3-.9.7-.9 1.1-2.6 1-4.8",
			fill: "#3e4347"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m46.4 26c0 10.7-6.5 19.4-14.5 19.4s-14.5-8.7-14.5-19.4c0-6.2 1.2-14.4 14.5-14.4 13.3 0 14.5 8.2 14.5 14.4",
			fill: "#8d9ba3"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 24,
			cy: 28.2,
			rx: 4.9,
			ry: 4.7,
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 24,
			cy: 28.2,
			rx: 3.4,
			ry: 3.3,
			fill: "#3e4347"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			className: "right-eye",
			cx: 39.7,
			cy: 28.2,
			rx: 4.9,
			ry: 4.7
		}),
		/* @__PURE__ */ _jsxs("g", {
			className: "right-eye",
			children: [
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 39.7,
					cy: 28.2,
					rx: 3.4,
					ry: 3.3
				}),
				/* @__PURE__ */ _jsx("path", { d: "m24.6 37.3c3.5.6 3.7.6 5.4 4" }),
				/* @__PURE__ */ _jsx("path", { d: "m39.2 37.3c-3.5.6-3.7.6-5.4 4" })
			]
		}),
		/* @__PURE__ */ _jsxs("g", {
			fill: "#89664c",
			children: [/* @__PURE__ */ _jsx("path", { d: "m58.1 5c-1.2-1.3-2.7-2.2-4.2-2.6-1.5-.5-3.2-.4-4.7-.1-3.1.7-5.9 2.9-7.8 6-1 1.6-1.7 3.4-2.2 5.3-.2.9-.4 1.9-.5 2.9-.2 2 3.8 2.6 4.4-1.4.2-1.3.8-2.6 1.4-3.7 1.3-2.3 3.2-3.9 5.4-4.5 1.1-.3 2.2-.4 3.2-.1 1 .3 2 .8 2.9 1.6 1.7 1.6 2.8 4.3 2.9 7.1.1 2.6-1.2 5.3-3.1 6.4-.9.6-2 .9-3 .7-1-.2-1.9-.9-2.6-1.9-.7-1-1-2.3-1-3.6 0-1.2.5-2.4 1.3-3.1.8-.7 1.9-1 2.7-.6.8.4 1.5 1.5 1.6 2.6 0 0 0 0 0 .1 0 .7.5 1.3 1.1 1.3.6 0 1-.6 1-1.4v-.1c0 0 0 0 0 0-.1-2.2-1.2-4.2-2.8-5.1-.8-.4-1.7-.5-2.5-.4-.4.1-.8.2-1.2.4-.2.1-.4.2-.6.4l-.2.2c-.1.1-.2.2-.3.2-1.4 1.2-2.3 3.2-2.4 5.4-.1 2.1.4 4.2 1.4 5.8 1 1.6 2.5 2.8 4.1 3.2 1.6.4 3.3 0 4.7-.8 1.5-.8 2.7-2.2 3.6-3.9.9-1.7 1.4-3.7 1.4-5.8 0-4-1.5-8-4-10.5" }), /* @__PURE__ */ _jsx("path", { d: "m5.9 5c1.2-1.3 2.7-2.2 4.2-2.6 1.5-.5 3.2-.4 4.7-.1 3.1.7 5.9 2.9 7.8 6 1 1.6 1.7 3.4 2.2 5.3.2.9.4 1.9.5 2.9.2 2-3.8 2.6-4.4-1.4-.2-1.3-.8-2.6-1.4-3.7-1.3-2.3-3.2-3.9-5.4-4.5-1.1-.3-2.2-.4-3.2-.1-1 .2-2.1.8-2.9 1.6-1.7 1.6-2.8 4.3-2.9 7.1-.1 2.6 1.2 5.3 3.1 6.4.9.6 2 .9 3 .7 1-.2 1.9-.9 2.6-1.9.7-1 1-2.3 1-3.6 0-1.2-.5-2.4-1.3-3.1-.8-.7-1.9-1-2.7-.6-.8.3-1.5 1.4-1.5 2.6 0 0 0 0 0 .1 0 .7-.5 1.3-1.1 1.3-.6 0-1-.6-1-1.4v-.1c0 0 0 0 0 0 .1-2.2 1.2-4.2 2.8-5.1.8-.4 1.7-.5 2.5-.4.4.1.8.2 1.2.4.2.1.4.2.6.4l.2.2c.1.1.2.2.3.2 1.4 1.2 2.3 3.2 2.4 5.4.1 2.1-.4 4.2-1.4 5.8-1 1.6-2.5 2.8-4.1 3.2-1.6.4-3.3 0-4.7-.8-1.5-.8-2.7-2.2-3.6-3.9-.9-1.7-1.4-3.7-1.4-5.8-.1-4 1.4-8 3.9-10.5" })]
		})
	]
});
const ForwardRef = forwardRef(SvgRam);
export default ForwardRef;
